import { Outlet } from "react-router-dom"
import ToastManager from "../ToastManager"
import './styles/index.scss'

// Public pages (login, forgot / reset password, verify e-mail). The logged-in app has its own ToastManager in
// PersistentLogin; here it is needed for the toasts of the public pages (e.g. "password changed" before the login).
const Layout = () => {
  return (
    <div className="main_container">
      <ToastManager />
      <Outlet />
    </div>
  )
}

export default Layout
